import * as THREE from 'three'
import './style.css'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'

// controle por mouse
// const cursor = {
//     x:0,
//     y:0
// }
// window.addEventListener('mousemove', function (e){
//     cursor.x = e.clientX / sizes.width -.5
//     cursor.y = e.clientY / sizes.width -.5
//
// })

/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', function (){
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    //update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)

})

window.addEventListener('dblclick', function () {
    if(!document.fullscreenElement){
        canvas.requestFullscreen()
    }
    document.exitFullscreen()
})

// Scene
const scene = new THREE.Scene()

// Object
const mesh = new THREE.Mesh(
    new THREE.BoxGeometry(1, 1, 1, 5, 5, 5),
    new THREE.MeshNormalMaterial({ wireframe : false })
    // new THREE.MeshBasicMaterial({
    //     color: 0x0000ff,
    //     wireframe: true
    // })
)
scene.add(mesh)


// Axes helper (triangulo rgb do mine)
// const axesHelper = new THREE.AxesHelper()
// scene.add(axesHelper)

// tipos de camera
// const aspectRatio = sizes.width / sizes.height
// const camera = new THREE.OrthographicCamera(
//     -1 * aspectRatio,
//     1 * aspectRatio,
//     1,
//     -1,
//     0.1,
//     100
// )

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 1, 1000)

// camera.position.x = 2
// camera.position.y = 2
camera.position.z = 4
camera.lookAt(mesh.position)
scene.add(camera)

//Controle pelo mouse via
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true


// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Animate
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update objects Animação de rotação do bloco
    // mesh.rotation.set(elapsedTime * .875,elapsedTime, 0)

    // update Camera
    // camera.position.x = Math.sin(cursor.x * Math.PI * 2) * 2
    // camera.position.z = Math.cos(cursor.x * Math.PI * 2) * 2
    // camera.position.y = - cursor.y * 5
    // camera.lookAt(mesh.position)

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()